<template>
  <div>
     <VForm class="mb-5" @submit.prevent="registerformData" >
            <div class="d-flex justify-center align-center">
              <VCard class="popupform" style="width: 100% !important">
                <div  @click="sendToParent()">
                  <v-btn
                  color="#1f1f45">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                </div>
                <div class="popupform_row row mt-2">
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">UserName</label>

                    <v-text-field
                      class="login-form551"
                      v-model="registerDetails.username"
                      required
                      :rules="overallFormValidation"
                      prepend-inner-icon="mdi-account"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Email</label>

                    <v-text-field
                      class="login-form551"
                      v-model="registerDetails.email"
                      required
                      :rules="[requiredValidator, emailValidator]"
                      prepend-inner-icon="mdi-email"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Password</label>

                  <v-text-field
  v-model="registerDetails.password"
  class="login-form551"
  :type="showPassword ? 'text' : 'password'"
  required
  :rules="[
    v => !!v || 'Password is required',
  ]"
  :prepend-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
  @click:prepend-inner="showPassword = !showPassword"
  variant="outlined"
/>

                  </div>
                  <div class="row">
                    <div class="col-md-8">
                      <!-- <input type="checkbox" checked />
                      <label style="font-size: 15px" class="ms-2"
                        >Send me special offers on email or whatsApp.</label
                      > -->
                    </div>

                    <div class="col-md-4">
                      <div>
                        <VBtn
                          width="50%"
                          class="but-color"
                          type="submit"
                          :disabled="!registerValidation"
                          block
                        >
                          <VProgressCircular
                            color="white"
                            v-if="goLoader"
                            indeterminate
                          />
                          {{ !goLoader ? "Submit" : "" }}
                        </VBtn>
                      </div>
                    </div>
                  </div>

                  <!-- <VCol cols="2" /> -->
                </div>
              </VCard>
            </div>
          </VForm>
  </div>
</template>

<script >

export default{
    data (){
    return{
           registerDetails:{
username:"",
email:"",
password:""
      },
      goLoader: false,
      shipId:"",
      showPassword:false,
      
    }
},
methods:{
     validateEmail(email) {
      return /.+@.+\..+/.test(email);
    },
registerformData() {
  this.goLoader=true
      this.$emit("updateformValue", this.registerDetails); 
    console.log('registerformData')
},
sendToParent() {
      this.$emit("updateValue", 'loginFormDetail'); 
    }
},

 computed: {
 registerValidation() {
      return (
        this.registerDetails.password !== "" &&
        this.registerDetails.username !== "" &&
         this.validateEmail(this.registerDetails.email) &&
        this.registerDetails.email !== ""
      );
    },
 },
}

</script>

<style scoped>
@import "@/assets/formResponce.css";
>>>.v-field--center-affix .v-field__prepend-inner {
    padding-top: 12px !important;
}
>>>.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
   background: none !important;
       POSITION: relative !important;
    top: -7px !important;

}
>>>.postal-form .v-field__input {
    top: -2px !important;
}
>>>.v-input__control {
    display: flex;
    grid-area: control;
    height: 40px;
}
>>>.v-field--focused .v-field__prepend-inner, .v-field--focused .v-field__append-inner {
    opacity: 1;
    height: 40px !important;
}
>>>.v-field--center-affix .v-field__prepend-inner {
    align-items: center;
    padding-top: 0 !important;
    height: 40px;
}
</style>